module.exports = __webpack_public_path__ + "static/media/GT-Haptik-Bold-Oblique.cf461786.eot";